import React, { useState } from "react";
import Icon from "../../assets/icons/Icon";
import { isMobileView } from "./CommonFunctions";

const Select = ({ 
  id, 
  label, 
  placeholder, 
  options = [], 
  optionGroups = [], 
  value = "", 
  onChange, 
  icon, 
  multiple = false, 
  errorMessage = '', 
  disabled,
  fetchAllObject,
    infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null,
  isMandatory
}) =>{const [showInfoText,setShowInfoText]=useState(false); 
  
  
  return (

  // console.log("options", options),
  <div className="flex flex-col gap-1">
    {label && (
        <label className={`inline-flex items-center gap-1 ${errorMessage ? "text-red-700" : "text-[#000000]"}`}>
         {label} {isMandatory && <span className="text-red-700">*</span>}
          {infoText && (
                  <div className="relative inline-flex group">
                    <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{setShowInfoText(true)}} onMouseLeave={()=>{setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                      i
                    </span>
      {showInfoText && (
        <div
          className={`
            z-50 px-3 py-2 rounded whitespace-normal
            ${isMobileView()
              ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
              : `
                absolute bg-[#4A1E73] text-[#FFFFFF] 
                ${getTooltipPositionClasses(tooltipPosition)}
                ${tooltipOffset ? `m-${tooltipOffset}` : ""}
              `
            }
          `}
          style={{
            width: isMobileView() ? "100%" : tooltipWidth || undefined,
          }}
        >
          {isMobileView() && (
            <span
              className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setShowInfoText(false);
              }}
              aria-label="Close tooltip"
            >
              <span className="w-4">
                <Icon type="remove" />
              </span>
            </span>
          )}
          {infoText}
        </div>
      )}
      
                  </div>
                )}
        </label>
      )}
    <div className="">
      {icon && <span className="select-icon">{icon}</span>}
      <select
        disabled={disabled}
        className={`h-[34px] border-[1px] text-[14px] rounded-lg hover:border-[#408dfb] text-gray-700 bg-white
          ${errorMessage ? 'border-red-500' : 'border-[#d7d5e2]'} 
          ${disabled && "bg-[#EEEEEE] cursor-not-allowed"} 
           w-full px-3`}
        id={id}
        value={multiple ? value || [] : value}
        onChange={(e) => {
          if (multiple) {
            const selectedOptions = Array.from(
              e.target.selectedOptions,
              (option) => option.value
            );
            onChange({ value: selectedOptions }); // Modified to match your expected format
          } else {
            if (fetchAllObject) {
              // Find selected option in either options or optionGroups
              let selectedOption = options.find(opt => opt.value === e.target.value);
              if (!selectedOption && optionGroups.length > 0) {
                for (const group of optionGroups) {
                  selectedOption = group.data.find(opt => opt.value === e.target.value);
                  if (selectedOption) break;
                }
              }
              onChange(selectedOption || { value: e.target.value });
            } else {
              onChange(e);
            }
          }
        }}
        multiple={multiple}
      >
        <option disabled value="">
          {placeholder || "select any"}
        </option>
        
        {/* Render regular options */}
        {options.map((option, index) => (
          <option key={`opt-${index}`} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
        
        {/* Render option groups if provided */}
        {optionGroups.map((group, groupIndex) => (
          <optgroup key={`group-${groupIndex}`} label={group.groupName}>
            {group.data.map((option, optionIndex) => (
              <option 
                key={`group-${groupIndex}-opt-${optionIndex}`} 
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {errorMessage && <span className="text-red-500 text-sm font-medium">{errorMessage}</span>}
    </div>
  </div>
);
}

const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
  }
};

export default Select;